export default __webpack_public_path__ + "static/media/REL-DIN-32A-OWON.e123f6cd.png";